import React from "react";
import { useState } from "react";
import moment from "moment";
import { MainText } from "app/components/common";

const displayCounter = counter => {
  var d = new Date(counter * 1000);
  return moment(d).format("mm:ss");
};

interface Props {
  isPlaying: boolean;
}

const Timer = ({ isPlaying }: Props) => {
  const [time, setTime] = useState(0);

  let intervalRef = React.useRef<number | null>(0);

  React.useEffect(() => {
    if (isPlaying) {
      setTime(0);
      intervalRef.current = setInterval(() => setTime(prev => prev + 1), 1000);
    } else {
      clearInterval(intervalRef.current);
    }
  }, [isPlaying]);

  return <MainText variant="l4-medium">{displayCounter(time)}</MainText>;
};

export default Timer;
